/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Default data stream
 * https://analytics.google.com/analytics/web/#/a126111315p280644069/admin/streams/table/2718047093
 */
let measurementId = 'G-EMNGKSFN2K';

const scriptSource = 'https://www.googletagmanager.com/gtag/js';
const scriptId = 'gtag-js';

declare const gtag: any;

export function loadGoogleTagManager(measurementIdOverride?: string): void {
  if (document.querySelector(`script#${scriptId}`)) {
    return;
  }
  if (typeof measurementIdOverride === 'string') {
    measurementId = measurementIdOverride;
  }
  /* <script async src="https://www.googletagmanager.com/gtag/js?id=G-EMNGKSFN2K"></script> */
  const script = document.createElement('script');
  script.id = scriptId;
  script.async = true;
  script.src = scriptSource + `?id=${measurementId}`;
  document.body.appendChild(script);

  /**
   * window.dataLayer = window.dataLayer || [];
   * function gtag(){dataLayer.push(arguments);}
   * gtag('js', new Date());
   * gtag('config', 'G-EMNGKSFN2K');
   */
  const dataLayer = (window as any).dataLayer || [];
  const gtag: Function = function gtag() {
    dataLayer.push(arguments); // eslint-disable-line prefer-rest-params
  };
  Object.assign(window, { dataLayer, gtag });

  gtag('js', new Date());
  gtag('config', measurementId);
  setPagePath(window.location.hash.slice(1));
}

// https://developers.google.com/analytics/devguides/collection/gtagjs/single-page-applications#measure_virtual_pageviews
// https://developers.google.com/analytics/devguides/collection/gtagjs/pages#default_behavior
export function setPagePath(pagePath: string, pageTitle?: string): void {
  if (gtagReady()) {
    gtag('config', measurementId, { page_path: pagePath, page_title: pageTitle });
  }
}

export function sendEvent(eventName: string, eventParameters?: Record<string, any>): void {
  if (gtagReady()) {
    gtag('event', eventName, eventParameters);
  }
}

function gtagReady(): boolean {
  return typeof gtag === 'function';
}
